import React from 'react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // TODO log error
    console.error('ERROR', { error, errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className='t-text-center'>
          <div className='t-rounded t-border t-border-slate-500 t-bg-slate-100 t-text-slate-700 t-p-5 t-inline-flex t-items-center t-my-5 t-gap-5 t-mx-auto'>
            <i className='fa fa-exclamation-triangle fa-3x t-text-slate-500' />
            <p className='t-flex-auto'>
              <em>Something unexpected happened and the designer has crashed!</em>
            </p>
          </div>
        </div>
      );
    } else {
      return this.props.children;
    }
  }
}
